import React, { useState, useEffect } from "react";
import { useGlobal } from "../../global/user";
import { FormulaModal, PermissionModal } from "../modal";
import sleep from "./sleep";
import { Button, message, Modal } from "antd";
import { SettingIcon, ReTryIcon } from "../Icons";
import "./function.css";
import { Cable } from "../../api";
import axios from "axios";

export default function Function2({ machineID, data, machineInfo, setStatus }) {
  const { user } = useGlobal();
  const [A, setA] = useState(data.a || 1);
  const [B, setB] = useState(data.b || 0);
  const [onEdit, setOnEdit] = useState(false);
  const [onOff, setOnOff] = useState("--");
  const [voltage, setVoltage] = useState("--");
  const [current, setCurrent] = useState("--");
  const [resistance, setResistance] = useState("--");
  const [editPermission, setEditPermission] = useState(false);
  const [permissionID, setPermissionID] = useState(1);
  const [passwords, setPasswords] = useState([data.password1, data.password2, data.password3, data.password4, data.password5]);
  const [names, setNames] = useState([data.name1, data.name2, data.name3, data.name4, data.name5]);
  const { IP, port, name } = machineInfo;
  const [isRestarting, setIsRestarting] = useState(false);

  useEffect(() => {
    axios
      .get(`http://${IP}:${port}/init_stat?nodeID=1`)
      .then((response) => {
        if (response.status === 200) setStatus(1);
        setTimeout(() => {
          axios.get(`http://${IP}:${port}/get_stat`).then((response) => {
            const { onOff, current, resistance, voltage } = response.data;
            onOff === 1 ? setOnOff("ON") : setOnOff("OFF");
            setCurrent(calculate(current));
            setResistance(calculate(resistance));
            setVoltage(calculate(voltage));
          });
        }, 1000);
      })
      .catch(() => setStatus(0));
  }, []);
  const calculate = (value) => {
    if (value === "--") return value;
    return Math.round((A * parseFloat(value) + B) * 100) / 100;
  };

  const ReloadData = async () => {
    let response = await Cable.CableInit(IP, port);
    if (response.code !== 200) {
      message.error(response.message);
      return;
    }
    for (let i = 0; i < 3; i++) {
      await sleep(5000);
      response = await Cable.CableGetData(IP, port);
      if (response.code === 200) {
        break;
      }
    }
    if (response.code === 200) {
      setVoltage(response.data.voltage);
      setCurrent(response.data.current);
      setResistance(response.data.resistance);
      setOnOff(response.data.onOff);
    } else message.error(response.message);
  };

  const ReloadConfirm = () =>
    Modal.confirm({
      title: `確認刷新`,
      content: `確認刷新索道 ${name} `,
      onOk: ReloadData,
    });

  const openEditPermission = async () => {
    setEditPermission(true);
  };

  const cableRestart = async () => {
    setIsRestarting(true);
    try {
      let response = await Cable.CableRestart();
      if (response.data?.overall_success) {
        message.success(`編號：${machineID} 索道重啟成功`);
      } else {
        console.error(`編號：${machineID} 索道重啟失敗`, response);
        message.error(`編號：${machineID} 索道重啟失敗`);
      }
    } catch (err) {
      console.error(`編號：${machineID} 索道重啟失敗:`, err);
      message.error(`編號：${machineID} 索道重啟失敗`);
    } finally {
      setIsRestarting(false);
    }
  };

  return (
    <React.Fragment>
      <td>
        <div className="d-flex justify-content-center py-2">
          <div style={{ width: "90%" }}>
            <div className="d-flex justify-content-between">
              <div>
                <span className="font-weight-bold mr-1">{`編號:`}</span>
                <span className="mr-2 text-nowrap">{`${machineID}`}</span>
              </div>
              <div>
                <span className="font-weight-bold mr-1">{`開關:`}</span>
                <span className="mr-2 text-nowrap">{`${onOff}`}</span>
              </div>
              <div>
                <span className="font-weight-bold mr-1">{`電壓:`}</span>
                <span className="mr-2 text-nowrap">{`${data.status !== -1 ? calculate(voltage) : "--"}`}</span>
              </div>
              <div>
                <span className="font-weight-bold mr-1">{`特徵:`}</span>
                <span className="mr-2 text-nowrap">{`${data.status !== -1 ? calculate(current) : "--"}`}</span>
              </div>
              <div>
                <span className="font-weight-bold mr-1">{`回充:`}</span>
                <span className="mr-2 text-nowrap">{`${data.status !== -1 ? calculate(resistance) : "--"}`}</span>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-2">
              <button className="control_setting" onClick={ReloadConfirm}>
                <ReTryIcon className="button_svg control_svg" />
              </button>
              {user.class >= process.env.REACT_APP_EDITOR_CALSS_LV && (
                <>
                  <button className="control_setting" onClick={() => setOnEdit(true)}>
                    <SettingIcon className="button_svg control_svg" />
                  </button>
                  <br />
                  <Button style={{height: 40, fontWeight:500, marginLeft:5}} onClick={openEditPermission}>
                    編輯權限
                  </Button>
                  <Button
                    style={{ height: 40, fontWeight: 500, marginLeft: 5 }}
                    onClick={cableRestart}
                    loading={isRestarting}
                    disabled={isRestarting}
                  >
                    索道重啟
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
        <FormulaModal visible={onEdit} setA={setA} setB={setB} A={A} B={B} data={data} setVisible={setOnEdit} type="索道" />
        <PermissionModal
          visible={editPermission}
          machineID={machineID}
          machineInfo={machineInfo}
          passwords={passwords}
          setPasswords={setPasswords}
          permissionID={permissionID}
          setPermissionID={setPermissionID}
          names={names}
          setNames={setNames}
          setEditPermission={setEditPermission}
        />
      </td>
    </React.Fragment>
  );
}
